import React, { Component } from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import VocabularyList from './VocabularyList';
import VocabularyListService from '../services/VocabularyListService';

class VocabularyListContainer extends Component {
  componentDidMount() {
    VocabularyListService.init();
  }

  render() {
    return (
      <VocabularyList
        vocabularies={toJS(VocabularyListService.vocabularies)}
        fetching={VocabularyListService.fetch.fetching}
        pagination={toJS(VocabularyListService.pagination)}
        onChange={VocabularyListService.load}
        onRestore={VocabularyListService.handleRestore}
        onDisable={VocabularyListService.handleDisable}
      />
    );
  }
}

export default observer(VocabularyListContainer);
